import { useAppStore } from "../../../hooks/store/useAppStore";
import {
  setShowHotspotModalSelector, setHotspotActiveIndexSelector
} from "../../../hooks/store/setters";
import DefaultHotspot from './DefaultHotspot';
import { setHotspotPauseAudioSelector } from "../../../hooks/store/setters";


const PointHotspot = (props) => {
    
    const setShowHotspotModal = useAppStore(setShowHotspotModalSelector);
    const setHotspotIndex = useAppStore(setHotspotActiveIndexSelector);
    const setHotspotPauseAudio = useAppStore(setHotspotPauseAudioSelector);
    
    const { hotspot, index } = props;

    const showHotspotModel = () => {
        setShowHotspotModal(true);
        setHotspotPauseAudio(false);
        setHotspotIndex(index);
    }
        
    return (
        <DefaultHotspot hotspot={hotspot} index={index} onClick={showHotspotModel} />
    );
};

export default PointHotspot;
